// Simple Mock Authentication Service for Offline Mode
import mockUserData from "../../store/mock/data/mockUser.json";
import store from "../../vuex/store";

class MockAuthenticationService {
  constructor() {
    this.currentUser = null;
  }

  // Get current user - just return the hardcoded mock user
  async getUser() {
    if (!this.currentUser) {
      // Use the single mock user from JSON
      const userData = mockUserData.mockUser;

      // Create simple user object
      this.currentUser = {
        access_token: userData.access_token,
        profile: userData.profile,
        expires_in: userData.expires_in,
        token_type: userData.token_type,
        scope: Array.isArray(userData.scope)
          ? userData.scope.join(" ")
          : userData.scope,
      };

      // Set user data in store
      this.updateStore();
    }

    return this.currentUser;
  }

  // Update Vuex store with user permissions
  updateStore() {
    if (!this.currentUser) return;

    const profile = this.currentUser.profile;

    // Set basic user info
    store.commit("authentication/setUser", this.currentUser);
    store.commit("authentication/logIn");
    store.commit("authentication/setUserName", profile.name);
    store.commit(
      "authentication/setAccessToken",
      this.currentUser.access_token
    );
    store.commit(
      "authentication/setsubid",
      profile.username || profile.sub || profile.preferred_username
    );
    store.commit("authentication/setSasToken", profile.sastoken);

    // Set permissions based on token structure
    const canViewNPD = !!(
      profile["ixp_researchxp.access"] === "true" ||
      profile.role === "superUser"
    );
    store.commit("authentication/canViewNPD", canViewNPD);

    // Note: Market-specific admin permissions (canEditAssets, canManageTaxonomies, canUploadLargeFiles)
    // are now handled reactively in the authentication store getter and actions
    // They will be updated when a market is selected

    console.log("🔌 Mock user loaded:", profile.name);

    // Trigger market permissions update after user is set
    // This will handle cases where a market is already selected
    store.dispatch("authentication/updateMarketPermissions");
  }

  // Simple signin methods that just return the user
  async signinRedirect() {
    return this.getUser();
  }

  async signinCallback() {
    return this.getUser();
  }

  async signinSilentCallback() {
    return this.getUser();
  }

  async getUserAccessToken() {
    const user = await this.getUser();
    return user ? user.access_token : "";
  }

  async signoutRedirect() {
    this.currentUser = null;
    store.commit("authentication/logOut");
  }
}

// Export singleton instance
export default new MockAuthenticationService();
